module.exports = __webpack_public_path__ + "static/media/15.7391968e.jpg";